import { ROUTES } from "@/constants/routes";

const equalsOrNoSlash = (pathname: string, route: string): boolean => {
  const noSlash = route.endsWith("/") ? route.slice(0, -1) : route;
  return pathname === route || pathname === noSlash;
};

/**
 * Regex pattern for magic link URLs with dynamic slugs
 * @param basePath - The base path ("/provider-test" or "/api/v1/provider-test")
 * @returns RegExp that matches basePath/{slug}/
 */
export const createMagicLinkPattern = (basePath: string): RegExp => {
  const normalizedBase = basePath.replace(/\/$/, ""); // Remove trailing slash
  return new RegExp(`^${normalizedBase}\/[^/]+\/?$`);
};

export const isPublicRoute = (pathname: string): boolean => {
  // Dynamic public route for magic link
  const magicLinkPattern = createMagicLinkPattern(ROUTES.PROVIDER_TEST);
  if (magicLinkPattern.test(pathname)) return true;

  // Static public routes
  const publicRoutes = [
    ROUTES.PROVIDER_REGISTER,
    ROUTES.LOGIN,
    ROUTES.REGISTER,
    ROUTES.PASSWORD_RESET,
    ROUTES.PASSWORD_RESET_CONFIRM,
    ROUTES.LOADING,
    ROUTES.TREATMENTS_LOGIN,
    ROUTES.TREATMENTS_REGISTER,
    ROUTES.MALE_PARTNER_ELIGIBILITY,
    ROUTES.MALE_PARTNER_REGISTER,
    ROUTES.MALE_PARTNER_LOGIN,
    ROUTES.UI_GALLERY,
  ];
  if (publicRoutes.some((route) => equalsOrNoSlash(pathname, route)))
    return true;

  return false;
};
